<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
        <div class="col darkBlue">
          <h3>
            <i class="fas fa-star"></i> S&P Rating Report
          </h3>
        </div>
        <div class="text-right">
          <label class="custom-toggle">
            <input v-model="ratingBuyOrSell" type="checkbox" @change="setRatingReportData" id="spCheck" />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div class="chart">
        <canvas id="ratingChartSP"></canvas>
      </div>
      <a href @click="showPopup" class="view-more">View More<i class="fa fa-arrow-circle-right" ></i></a>
      <!-- <a href class="text-right view-more" @click="showPopup">View More</a> -->
    </div>
    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-xl"
      id="chartViewMoreRatingSP"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">S&P Rating Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="col-lg-9 col-5 tradeDate">
                <!-- <h4>Trade Date Range</h4>
                <form>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">From</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupFromDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupRatingReportData"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">To</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupToDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupRatingReportData"
                    />
                  </div>
                </form> -->
              </div>
               <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input type="checkbox" v-model="popupRatingBuyOrSell" @change="setPopupRatingReportData">
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
              <!-- <div class="text-right">
                <label class="custom-toggle">
                  <input
                    v-model="popupRatingBuyOrSell"
                    type="checkbox"
                    @change="setPopupRatingReportData"
                  />
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
              </div> -->
            </div>
            <div class="graph">
              <canvas id="popUpRatingChartSP"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
export default {
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getRatingReportData();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      ratingBuyOrSell: false,
      ratingChartOptions: chartConstants.spRatingBarChartDefault,
      ratingChartData: {},
      popupRatingChartOptions: chartConstants.spRatingBarChartDefaultPopup,
      popupRatingChartData: {},
      popupRatingBuyOrSell: false,
      myChart  : null,
      myChartPoup : null
      // popupFromDate: this.fromdate,
      // popupToDate: this.todate
    };
  },
  methods: {
    getRatingReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/rating?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True&ratingsType=SandP",
          auth
        )
        .then(result => {
          this.ratingChartData = result.data.data;
          this.setRatingReportData();
        });
    },
    setRatingReportData() {
      this.ratingChartOptions.data.labels = this.ratingBuyOrSell ? this.ratingChartData.sellsRatings : this.ratingChartData.buysRatings;
      this.ratingChartOptions.data.datasets[0].data = this.ratingBuyOrSell
        ? this.ratingChartData.sells
        : this.ratingChartData.buys;

      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("ratingChartSP");
      this.myChart = new window.Chart(ctx, {
        type: this.ratingChartOptions.type,
        data: this.ratingChartOptions.data,
        options: this.ratingChartOptions.options
      });
    },
    getPopupRatingReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/rating?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false&ratingsType=SandP",
          auth
        )
        .then(result => {
          this.popupRatingChartData = result.data.data;
          this.setPopupRatingReportData();
        });
    },
    setPopupRatingReportData() {
      this.popupRatingChartOptions.data.labels = this.popupRatingBuyOrSell ? this.popupRatingChartData.sellsRatings : this.popupRatingChartData.buysRatings;
      this.popupRatingChartOptions.data.datasets[0].data = this
        .popupRatingBuyOrSell
        ? this.popupRatingChartData.sells
        : this.popupRatingChartData.buys;
      if(this.myChartPoup ){
        this.myChartPoup.destroy();
      }
      const ctx = document.getElementById("popUpRatingChartSP");
      this.myChartPoup = new window.Chart(ctx, {
        type: this.popupRatingChartOptions.type,
        data: this.popupRatingChartOptions.data,
        options: this.popupRatingChartOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      this.getPopupRatingReportData();
      window.$("#chartViewMoreRatingSP").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getRatingReportData();
      }
    });
  }
};
</script>